import createApp from '@shopify/app-bridge';

export default {
    install(Vue) {
        const shopOrigin = 'mode-boards.myshopify.com';
        const apiKey = process.env.VUE_APP_SHOPIFY_API_KEY;
        const redirectUri = process.env.VUE_APP_OAUTH_REDIRECT_URI;
        const permissionUrl = `https://${shopOrigin}/admin/oauth/authorize?client_id=${apiKey}&scope=write_orders,read_products,read_all_orders,read_customers&redirect_uri=${redirectUri}`;
        const app = createApp({
            apiKey: apiKey,
            shopOrigin: shopOrigin
        });

        Vue.shopifyAppBridge = app;
    }
};
